import { Box } from "@mui/material"
import React from "react"
import { playerStore } from "src/store/PlayerStore"

import { ProgressBar } from "../ProgressBar/ProgressBar"

export const ProgressContainer = () => {
  const content = playerStore((state) => state.content)
  const isPreview = playerStore((state) => state.isPreview)

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
      }}
    >
      {(content?.__typename !== "LiveConcert" || isPreview) && <ProgressBar />}
    </Box>
  )
}
